import { IScenarioChangeRequest } from '../../interfaces/iscenario-change-request';
import { ChangeRequest } from '../change-request';
import { Scenario } from '../scenario';

export class ScenarioChangeRequestBase {
  ScenarioChangeRequestId: number;
  ChangeRequestId: number;
  ScenarioId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ChangeRequest?: ChangeRequest;
  Scenario?: Scenario;

  constructor(item?: IScenarioChangeRequest) {
    if (item) {

      this.ScenarioChangeRequestId = item.ScenarioChangeRequestId;
      this.ChangeRequestId = item.ChangeRequestId;
      this.ScenarioId = item.ScenarioId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ChangeRequest = new ChangeRequest(item.ChangeRequest);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}